import type {ControlOption} from 'shells/card/segmented-control';

import type {DigestFrequencyEnum, DigestTypeEnum} from 'nutshell-graphql-types';

export const FREQUENCY_OPTIONS: ControlOption<DigestFrequencyEnum>[] = [
    {
        type: 'small',
        title: 'Weekly',
        value: 'WEEKLY',
    },
    {
        type: 'small',
        title: 'Daily',
        value: 'DAILY',
    },
];

export const DIGEST_TYPE_OPTIONS: ControlOption<DigestTypeEnum>[] = [
    {type: 'small', title: 'User digest', value: 'MORNING_DIGEST'},
    {type: 'small', title: 'Admin digest', value: 'TEAM_REPORT'},
];
